import * as React from 'react';

import * as styles from './MapLabel.css';

export interface IMapLabelProps {
  text: string;
}

export function MapLabel({ text }: IMapLabelProps) {
  return <div className={styles['label']}>{text}</div>;
}
